/**
 * Страница CRM внутри приложения мессенджера (владелец 02.10.2026: «Почему оформление старое, а не в виде
 * календаря CRM?»). CRM живёт на основном домене (/crm/), мессенджер — на поддомене: страница встаёт рамкой,
 * а CRM по ?embed=1 убирает своё меню. Вход у CRM свой: если в CRM не входили, рамка попросит войти.
 */
import { crmBase } from "@/lib/crmLink";

export function CrmFrame({ path, title }: { path: string; title: string }) {
  // В теме мессенджера: он ставит data-theme="dark" на <html>, светлая — без атрибута.
  const theme = document.documentElement.getAttribute("data-theme") === "dark" ? "dark" : "light";
  return (
    <iframe
      title={title}
      src={`${crmBase()}${path}${path.includes("?") ? "&" : "?"}theme=${theme}`}
      style={{ border: 0, width: "100%", height: "100%", display: "block", background: "var(--paper, #f4f4f5)" }}
    />
  );
}
